<template>
  <b-row class="mb-3 mt-3">
    <b-col cols="12">
		<div class="div-separator-prev" :style="{'color':data.config.color,'backgroundColor':data.config.backgroundColor}">
			<p class="p-separator-prev" v-html="data.content"></p>
		</div>
	</b-col>
  </b-row>
</template>
<style lang="scss" scoped>
.div-separator-prev{
  height:50px; 
  width: 100%;
  text-align: left;
  padding-left: 20px;
  font-size: 18px;
}
.p-separator-prev{
	padding-top: 10px;
	letter-spacing: 0.5px;
	font-weight: bold;
}
</style>

<script>
export default {
  name: "Subtitulo",
  props: {
    data: {
      type: Object
    }
  },
  created() {
    console.log(this.data);
  }
};
</script>